import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import { Box, Button, Collapse } from '@material-ui/core'

import Edit from './Edit'
import Display from './Display'
import MissingPhoneWarning from './MissingPhoneWarning'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPencil } from '@fortawesome/pro-solid-svg-icons'

export default class EditProfileForm extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    editUser: PropTypes.object.isRequired,
    onUpdate: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
  }
  state = {
    isEditing: false,
  }
  cancel() {
    this.setState(
      {
        isEditing: false,
      },
      () => {
        this.props.onCancel()
      },
    )
  }
  render() {
    const { editUser, className } = this.props
    const { isEditing } = this.state
    return (
      <div className={cn('edit-profile-form', className)}>
        <Collapse in={isEditing}>
          <Edit
            editUser={editUser}
            onUpdate={(...args) => this.props.onUpdate(...args)}
            showDisabledEmail
          />
          <br />
          <Box
            display="flex"
            justifyContent="flex-end"
          >
            <Button
              variant="text"
              color="primary"
              onClick={() => this.cancel()}
            >
              Cancel
            </Button>
          </Box>
        </Collapse>
        <Collapse in={!isEditing}>
          <Box
            display="flex"
            alignItems="flex-start"
            justifyContent="space-between"
          >
            <Display
              user={editUser}
              showEmail
            />
            <Box>
              <Button
                className="edit-button"
                variant="text"
                color="primary"
                onClick={() => this.setState({ isEditing: true })}
                startIcon={<FontAwesomeIcon icon={faPencil} />}
              >
                Edit
              </Button>
            </Box>
          </Box>
        </Collapse>
        <MissingPhoneWarning user={editUser} />
      </div>
    )
  }
}
